/**
 * Inbound mail host for artist inboxes (Mailgun). The local part is the user's username.
 * Override in env if staging uses a different subdomain.
 */
const DEFAULT_DIZEE_INBOX_DOMAIN = 'email.dizee.com'

export function getDizeeInboxDomain(): string {
  const v = (import.meta.env.VITE_DIZEE_INBOX_DOMAIN as string | undefined)?.trim()
  return v || DEFAULT_DIZEE_INBOX_DOMAIN
}

export function dizeeInboxAddress(localPart: string): string {
  const local = (localPart || 'username').trim()
  return `${local}@${getDizeeInboxDomain()}`
}
